import { useMemo } from 'react'
import { TYPE_CUSTOMER_PRODUCT, TYPE_MESSAGE_GROUP, TYPE_USER } from '../constants/avatar'
import avatarPlaceholderFallback from '../assets/images/avatar-placeholder-fallback.svg'
import avatarPlaceholderUser from '../assets/images/avatar-placeholder-user.svg'

export default (placeholder, type, hasCount = false) => useMemo(() => {
  if (placeholder) {
    return placeholder
  }
  if (hasCount) {
    return undefined
  }

  switch (type) {
    case TYPE_USER:
      return avatarPlaceholderUser
    case TYPE_MESSAGE_GROUP:
    case TYPE_CUSTOMER_PRODUCT:
    default:
      return avatarPlaceholderFallback
  }
}, [placeholder, type, hasCount])
